<template>
    <div class="add-new-creative add-new-creative-wrap">
        <md-dialog :md-active.sync="showDialog" >
           <validation-observer v-slot="{ handleSubmit }" tag="div">
            <form @submit.prevent="handleSubmit(addNewCreative)">
            <md-dialog-title>
                <span>Add new creative</span>
                <button class="btn btn--close" @click="cancel"></button>
            </md-dialog-title>
            <div class="form__content"> 
                  <!-- <ValidationProvider rules="required" v-slot="{ errors }" tag="div">
                    <md-field>                      
                      <label>Client </label>                                    
                      <own-custom-select v-model="creative.parent_id" :defValue="creative.parent_id" :disable="board"  :placeholder='"Choose..."'>
                        <own-custom-select-option v-for="" :value=""></own-custom-select-option>                        
                      </own-custom-select>                      
                    </md-field>
                    <div class="form__error">{{ errors[0] }}</div>
                    <div class="form__error" v-if="error.height">warning</div>
                  </ValidationProvider> -->
                  <!-- <ValidationProvider rules="required" v-slot="{ errors }" tag="div">
                    <md-field>                      
                      <label>Brand  </label>                                    
                      <own-custom-select v-model="" :defValue="" :disable="board"  :placeholder='"Choose..."'>
                        <own-custom-select-option :value=""></own-custom-select-option>    
                      </own-custom-select>                      
                    </md-field>
                    <div class="form__error">{{ errors[0] }}</div>
                    <div class="form__error" v-if="error.height">warning</div>
                  </ValidationProvider>
                   <ValidationProvider rules="required" v-slot="{ errors }" tag="div">
                    <md-field>                      
                      <label>Campaign </label>                                    
                      <own-custom-select v-model="" :defValue="" :disable="board"  :placeholder='"Choose..."'>
                        <own-custom-select-option :value=""></own-custom-select-option>    
                      </own-custom-select>                      
                    </md-field>
                    <div class="form__error">{{ errors[0] }}</div>
                    <div class="form__error" v-if="error.height">warning</div>
                  </ValidationProvider>
                   <ValidationProvider rules="required" v-slot="{ errors }" tag="div">
                    <md-field>                      
                      <label>Board </label>                                    
                      <own-custom-select v-model="" :defValue="" :disable="board"  :placeholder='"Choose..."'>
                        <own-custom-select-option :value=""></own-custom-select-option>    
                      </own-custom-select>                      
                    </md-field>
                    <div class="form__error">{{ errors[0] }}</div>
                    <div class="form__error" v-if="error.height">warning</div>
                  </ValidationProvider> -->
                  <!--<ValidationProvider rules="required" v-slot="{ errors }" tag="div">
                    <md-field>                      
                      <label>Type</label>                                    
                      <own-custom-select v-model="creative.type" :defValue="creative.type" name="creativeType" id="creativeType" :placeholder='"Choose..."'>
                        <own-custom-select-option value="image">image</own-custom-select-option>
                        <own-custom-select-option value="pdf">pdf</own-custom-select-option>
                      </own-custom-select>                    
                    </md-field>
                    <div class="form__error">{{ errors[0] }}</div>
                    <div class="form__error" v-if="error.height">warning</div>
                  </ValidationProvider>-->
                  <ValidationProvider rules="required" v-slot="{ errors }" tag="div">
                    <md-field>
                      <md-icon v-if="error.thumb" class="md-accent">warning</md-icon>
                      <label>Creative files</label>               
                        <div class="md-file">
                          <input readonly="readonly" class="md-input" v-model="fileNamesToUpload" />
                          <input type="file" multiple accept="image/*,application/pdf" @change="filesSelected" />
                        </div>
                    </md-field>
                    <small>Select one or more image or pdf document to upload. Allowed extensions are: jpg, jpeg, png, svg, pdf</small>
                    <div class="form__error">{{ errors[0] }}</div>
                  </ValidationProvider>                               
            </div>
            <md-dialog-actions>
              <div class="md-layout" v-if ="!loading">
                <div class="md-layout-item">
                  <md-button class="md-primary modal-cancel-btn" @click="cancel">Cancel</md-button>
                </div>
                <div class="md-layout-item text-right">
                 <md-button class="md-primary modal-save-btn" type="submit">Save Creatives</md-button>
                </div>
              </div>
            </md-dialog-actions>
            </form>
          </validation-observer>
        </md-dialog>
        
        <div class="add-new-creative-big-btn" @click="showDialog = true" v-if="cardMode == true">
          <div class="add-new-creative-big-btn--img">
            <img src="@/assets/img/plus-bg-btn.svg" alt="plus"> 
          </div>
          <div class="add-new-creative-big-btn--txt" :class="customClass">
              ADD NEW creative
          </div>
        </div>
        <div v-else>
          <button class="btn btn-green logoutBtn" type="button" @click="showDialog = true">
            <img alt="Add Button" class="addButton" src="@/assets/img/icons/add.svg" />
            new creative
          </button>
        </div>
          
    </div>
</template>


<script>
import apiHandlerMI from "@/mixins/apiHandlerMI.js";
import {ValidationProvider, ValidationObserver, extend} from 'vee-validate';
import {required} from 'vee-validate/dist/rules';
import {setInteractionMode} from 'vee-validate';
//import OwnCustomSelect from '@/components/layoutComponents/OwnCustomSelect.vue'
//import OwnCustomSelectOption from '@/components/layoutComponents/OwnCustomSelectOption.vue'

setInteractionMode('eager');
extend('required', {
  ...required,
  message: "File need to upload."
});

export default {
  props:['board','cardMode', 'customClass'],
  mixins: [apiHandlerMI],
  data(){
    return{
      loading:false,
      showDialog: false,
      active: false,
      creative: {
        internal: 0,
        external_id: 0,
        width: 0,
        height: 0,
        type: 'image',
        parent_id :0,
        status: 'draft',
        comment_status: 'account',
        version: 0,
      },
      error: {},
      needUpload : false,
      type: 'rectangle',
      filesToUpload: null,
      fileNamesToUpload: undefined,
      creativeTypes:[
        {
          name: 'image',
          value: 'image'
        },
        {
          name: 'pdf',
          value: 'pdf'
        }
      ]      
    }
  },
  components: {
    ValidationProvider,
    ValidationObserver,
    //OwnCustomSelect,
    //OwnCustomSelectOption
  },
  methods:{
      
      filesSelected(event) {
        this.needUpload = true;
        this.creative.thumb = undefined;
        this.filesToUpload = event.target.files;
        var names = [];
        for (var i = 0; i < this.filesToUpload.length ; i++)
        {
          names.push(this.filesToUpload[i].name)
          }
          this.fileNamesToUpload = names.join(', ');
      },
      upload_selected: function(num) {
        //console.log('upload selected: ' +num)
        if (!this.needUpload)
          return false;
        const _this = this;
        if (!(this.filesToUpload || []).length) {
          
          this.error.thumb = "Image required!";
          this.$forceUpdate();
          return;
        }
       
        this.error.thumb  = undefined;
        if (this.filesToUpload.length <= num) {
          _this.showDialog = false;
          this.fileNamesToUpload = undefined;
          _this.filesToUpload = undefined
          //this.uploadSuccess = `You have successfully uploaded ${num} files`;
          setTimeout(() => {
            _this.uploadSuccess = undefined;
          }, 3000);
          return;
        }

        let file = this.filesToUpload[num];

        const formData = new FormData();
        formData.append("files[0]", file);
        formData.append("payment_cluster_id", this.board.payment_cluster_id);
       
        formData.append("folder",'brands');
        formData.append("upload_type", 'no_size'); //rectagne v. square ???

        var url = "image";
        if (this.filesToUpload[num].type == "application/pdf")
        {
          url = 'document'
          formData.append("pdf_image", 1);
        }
        
        
        this.post(
          "filemanager/upload/" + url,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data"
            }
          },
          function(resp) {
            //_this.needUpload = false;
            
            if (_this.filesToUpload[num].type == "application/pdf")
            {
                _this.creative.thumb = resp.data.documents[0].pdf_image.image.id
                _this.creative.width = parseInt( resp.data.documents[0].pdf_width);
                _this.creative.height = parseInt(resp.data.documents[0].pdf_height);
                _this.creative.unit = "mm"
                _this.creative.name = parseInt(_this.creative.width)+ "x"+parseInt(_this.creative.height)+ " mm";
                
                
                _this.creative.creative_file  = resp.data.documents[0].id

            }
            else
            {
                _this.creative.thumb = resp.data.images[0].id
                _this.creative.width = resp.data.images[0].image_size.width;
                _this.creative.height = resp.data.images[0].image_size.height;
                _this.creative.unit = "px";
                _this.creative.name = _this.creative.width+ "x"+_this.creative.height+ " px";
                _this.creative.creative_file  = resp.data.images[0].id
            }
          
            _this.addNewCreativeData();
            _this.upload_selected(num + 1);
          }
        );
      },
      addNewCreative(){
          this.loading = true;
          this.upload_selected(0);
        
      },
      addNewCreativeData(){
      
        var _this = this;
        this.creative.board_id = this.board.id;
        _this.creative.internal = 0;
        _this.creative.external_id = 0,
        this.post('creative',this.creative,{},function(resp){
         
          //console.log(_this.$parent,_this.$parent.refreshBrand)
          _this.creative.internal = 1;
          _this.creative.external_id = resp.data.result.creative.id
          _this.post('creative',_this.creative,{},function(resp2){
            _this.put('creative/'+resp.data.result.creative.id,{board_id: _this.creative.board_id,external_id : resp2.data.result.creative.id},{});
            _this.creative = {
                internal: 0,
                external_id: 0,
                width: 0,
                height: 0,
                type: 'image',
                parent_id :0,
                status: 'draft',
                comment_status: 'account',
                version: 0,
            };
            if (_this.$parent.refreshBrand)
            {
              //console.log('refresh')
              _this.$parent.refreshBrand();
              _this.loading = false;
            }
            
          })
          
        },function(resp){
           if (_this.$parent.refreshBrand)
           {
             //console.log('refresh')
             _this.$parent.refreshBrand();
             _this.loading = false;
           }
             //console.log(resp);
            _this.error = resp.data.error;
            this.$forceUpdate();
        })
      },
      cancel(){
        this.showDialog = false
        
      }
    }
 }

</script>